import gql from 'graphql-tag'

export const GET_SCHOOL_ROLES = gql`
  query ($schoolId: Int!) {
    academyRoles(schoolId: $schoolId) {
      name
      id
      insertedAt
      description
      permissions
    }
  }
`

export const GET_PERMISSIONS_AUDIT_HISTORIES = gql`
  query ($schoolId: Int!) {
    academyPermissionAuditHistories(schoolId: $schoolId) {
      action
      id
      effectiveFrom
      insertedAt
      newRoleId
      newRole {
        id
        name
        permissions
      }
      oldRoleId
      targetPersonalProfileId
      personalProfileId
    }
  }
`
